module.exports = __webpack_public_path__ + "img/sv64on.85c95e38.svg";